import * as React from "react"
import { SaleAdvert, SaleAdvertTranslation } from "../../../types/types";
import ReadMore from "../../shared/advert/ReadMore";
import SimpleFormat from "../../../utils/SimpleFormat";

type Props = {
  advert: SaleAdvert
  translation: SaleAdvertTranslation
}

export default (props: Props) : JSX.Element => (
  !!props.translation && props.translation.terrainBuildings ?
    <>
      <div className="content-part">
        <h3>
          {I18n.t('sale_adverts.description.buildings')}
        </h3>
        <div className="description">
          <ReadMore
            height={180}
          >
            <SimpleFormat
              text={props.translation.terrainBuildings}
            />
          </ReadMore>
        </div>
      </div>
      <hr/>
    </>
  : <></>
)
